import React, { Component } from "react";
import cloneDeep from "lodash/cloneDeep";
import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Select from "@cloudscape-design/components/select";
import SpaceBetween from "@cloudscape-design/components/space-between";
import DateRangePicker from "@cloudscape-design/components/date-range-picker";
import Multiselect from "@cloudscape-design/components/multiselect";
import Table from "@cloudscape-design/components/table";
import FormField from "@cloudscape-design/components/form-field";
import Container from "@cloudscape-design/components/container";
import ColumnLayout from "@cloudscape-design/components/column-layout";
import Textarea from "@cloudscape-design/components/textarea";
import Tabs from "@cloudscape-design/components/tabs";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { promotionAddModalStore, tournamentsAddModalStore } from "../stores/promotionAddModal";
import { tournamentsStore } from "../stores/tournaments";
import { gameStore } from "../stores/games";
import { Alert } from "react-bootstrap";
import Poster from "../assets/poster.png";
import ProgressiveImage from "react-progressive-graceful-image";

class PromotionAddModal extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.resetFormFields();
	}

	addPromotion = async() => {
		try {
			const { promotionAddModal, setPromotionAddModal, Interface } = this.props;


			const body = {
				...promotionAddModal,
				type: promotionAddModal.typePromo,
				start: promotionAddModal.startDate,
				end: promotionAddModal.endDate,
			};

			try {
				const result = await Interface.request("set", {
					class: "data",
					module: "promotion",
					method: "add"
				}, body);

				Interface.addNoty("Success", "Promotion was successfully added");
				Interface.loadPromotion();
				setPromotionAddModal({ ...promotionAddModal, show: false });
			} catch (error) {
				Interface.addNoty("Error", error.text || error.toString());
			}
		} catch (error) {
			console.log("ERROR PROMO", error);
		}
	}

	resetFormFields = () => {
		this.props.setPromotionAddModal({
			...this.props.promotionAddModal,
			type: "",
			typePromo: "",
			fromAmount: false,
			toAmount: false,
			startDate: "",
			endDate: "",
			percent: false,
			error: {
				text: "",
				code: 0,
				timestamp: 0,
			},
		});
	};

	updateParam = (key, value) => {
		const { promotionAddModal, setPromotionAddModal } = this.props;
		const updatedState = cloneDeep(promotionAddModal);
		updatedState[key] = value;
		setPromotionAddModal(updatedState);
	};



	render() {
		const { promotionAddModal, setPromotionAddModal } = this.props;

		return (
			<Modal
				visible={promotionAddModal.show}
				size="medium"
				onDismiss={() => setPromotionAddModal({ ...promotionAddModal, show: false })}
				header={`Add promotion`}
				children={
					<SpaceBetween direction="vertical" size="l">
						<Container>
							<SpaceBetween direction="vertical" size="m">
								<FormField
									label="Type"
									description="Promotion type"
									stretch
								>
									<Select
										selectedOption={promotionAddModal.typePromo ? {
											value: promotionAddModal.typePromo,
											label: promotionAddModal.typePromo
										} : null}
										placeholder={"Promotion type"}
										onChange={({ detail }) =>
											this.updateParam("typePromo", detail.selectedOption.value)
										}
										options={promotionAddModal.currentOption.type}
									/>
								</FormField>

								<FormField
									label="From amount Required"
									description="From amount"
									stretch
								>
									<Input
										type="number"
										value={promotionAddModal.fromAmount}
										onChange={({ detail }) =>
											this.updateParam(
												"fromAmount",
												detail.value === ""
													? ""
													: detail.value
											)
										}
										placeholder="1"
										inputMode="numeric"
									/>
								</FormField>

								<FormField
									label="To amount Required"
									description="To amount (inf-0)"
									stretch
								>
									<Input
										type="number"
										value={promotionAddModal.toAmount}
										onChange={({ detail }) =>
											this.updateParam(
												"toAmount",
												detail.value === ""
													? ""
													: detail.value
											)
										}
										placeholder="1"
										inputMode="numeric"
									/>
								</FormField>

								<FormField
									label="Precent Required"
									description="Precent"
									stretch
								>
									<Input
										type="number"
										value={promotionAddModal.percent}
										onChange={({ detail }) =>
											this.updateParam(
												"percent",
												detail.value === ""
													? ""
													: detail.value
											)
										}
										placeholder="1"
										inputMode="numeric"
									/>
								</FormField>
							</SpaceBetween>
						</Container>


						{/* Даты проведения */}
						<Container header={<Box variant="h2">Promotion Dates</Box>}>
							<FormField
								label="Start/end"
								description="Select the start and end dates for the tournament"
								stretch
							>
								<DateRangePicker
									onChange={({ detail }) => {
										setPromotionAddModal({
											...promotionAddModal,
											startDate: detail.value.startDate.split("+")[0],
											endDate: detail.value.endDate.split("+")[0],
											type: detail.value.type,
										});
									}}
									value={{
										startDate: promotionAddModal.startDate,
										endDate: promotionAddModal.endDate,
										type: "absolute",
									}}
									relativeOptions={[]}
									isValidRange={range => {
										if (range.type === "absolute") {
											const [startDateWithoutTime] = range.startDate.split("T");
											const [endDateWithoutTime] = range.endDate.split("T");
											if (!startDateWithoutTime || !endDateWithoutTime) {
												return {
													valid: false,
													errorMessage: "The selected date range is incomplete.",
												};
											}
											if (new Date(range.startDate) - new Date(range.endDate) > 0) {
												return {
													valid: false,
													errorMessage: "Start date must be before end date.",
												};
											}
										}
										return { valid: true };
									}}
									i18nStrings={{
										todayAriaLabel: "Today",
										nextMonthAriaLabel: "Next month",
										previousMonthAriaLabel: "Previous month",
										customRelativeRangeDurationLabel: "Duration",
										customRelativeRangeDurationPlaceholder: "Enter duration",
										customRelativeRangeOptionLabel: "Custom range",
										customRelativeRangeOptionDescription: "Define a custom range",
										customRelativeRangeUnitLabel: "Unit of time",
										formatRelativeRange: ({ startDate, endDate }) => {
											const start = new Date(startDate).toLocaleString("en-GB");
											const end = new Date(endDate).toLocaleString("en-GB");
											return `${start} - ${end}`;
										},
										formatUnit: (unit, amount) => `${unit}${amount > 1 ? "s" : ""}`,
										dateTimeConstraintText: "Date and time must be within range.",
										renderSelectedAbsoluteRangeAriaLive: (startDate, endDate) =>
											`Selected from ${startDate} to ${endDate}`,
										labelRelativeRange: "Relative range",
										labelAbsoluteRange: "Absolute range",
										dateTimePickerAriaLabel: "Date and time picker",
										dateTimePickerLabel: "Date and Time",
										clearButtonAriaLabel: "Clear date range",
										relativeModeTitle: "Relative mode",
										absoluteModeTitle: "Absolute mode",
										cancelButtonLabel: "Cancel",
										applyButtonLabel: "Apply",
									}}
								/>
							</FormField>
						</Container>
					</SpaceBetween>
				}
				footer={
					<Box float="right">
						<SpaceBetween direction="horizontal" size="m">
							<Button
								variant="normal"
								onClick={() =>
									setPromotionAddModal({ ...promotionAddModal, show: false })
								}
							>
								Close
							</Button>
							<Button
								variant="primary"
								onClick={this.addPromotion}
							>
								Save
							</Button>
						</SpaceBetween>
					</Box>
				}
			/>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const promotionAddModal = useRecoilValue(promotionAddModalStore);
		const setPromotionAddModal = useSetRecoilState(promotionAddModalStore);


		return (
			<Component
				{...props}
				setPromotionAddModal={setPromotionAddModal}
				promotionAddModal={promotionAddModal}
			/>
		);
	};
}

export default withRecoil(PromotionAddModal);
